/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import { CALENDER_SCREEN, COMMON, ALL_ROUTES } from '../../global/Constants';
//import Utilities from '../../global/Utilities';
import AcceptRejectButton from '../common/AcceptRejectButton';
import ViewOfflineImage from '../common/ViewOfflineImage';
import DataProvider from '../../providers/DataProvider';
import { HomeActivityType } from '../../global/Enum';

class SampleDistributionView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isFarmer: true,
            activity: null,
            data: null,
            address: "Fetching address..."
        }
    }

    componentDidMount() {

    }


    getFormattedDate() {
        let selectedDate = null;
        if (this.props.location.state !== undefined) {
            selectedDate = this.props.location.state.selectedDate;
            return Moment(selectedDate).format('dddd, DD MMM, yyyy');
        }
    }

    handleBack = () => {
        this.props.history.goBack();
    }



    getTypeSample = (type) => {
        type = parseInt(type);
        switch (type) {
            case 1:
                return "Free";
            case 2:
                return "S2S";
            case 3:
                return "Prerak";
            default:
                break;
        }
    }


    handleAcceptButton = () => {
        //this.props.history.goBack();

        const { activity, user } = this.props;
        const sampleDistribution = activity?.data;
        if (sampleDistribution?.is_s2s === 1) {

            const hybrid_name = DataProvider.getInstance().getHybridNameById(activity?.hybrid_id);
            const village_name = DataProvider.getInstance().getVillageNameById(activity?.village_id);

            let activityObj = {
                userId: activity.assigned_user_id,
                userName: this.getEmployeeNameById(activity.assigned_user_id),
                krishak_id: activity?.krishak_id,
                name: user?.name,
                phone: user?.phone,
                isDisable: true,
                cropId: activity?.crop_id,
                hybrid: { value: activity?.hybrid_id, label: hybrid_name },
                village: { value: activity?.village_id, label: village_name }
            }
            this.props.history.replace({
                pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                state: { selectedActivity: HomeActivityType.SAMPLE_TO_SALE, selectedActivityId: 4, activity: activityObj }
            });
        } else {
            this.props.history.goBack();
        }
    }

    handleRejectButton = () => {
        this.props.history.goBack();
    }

   

    getEmployeeNameById = (userId) => {
        const employee = DataProvider.getInstance().getEmployeeById(userId);
        if (employee) {
            return employee.name;
        }
        return "";
    }

    getNearbyRetailersById = (retailers) => {
        //Utilities.LogPrint("Retailers", retailers);
        const retailersArray = DataProvider.getInstance().getRetailers();
        //Utilities.LogPrint("Retailers", retailersArray);
        if (retailers !== undefined && retailers?.length > 0) {
            const selectedRetailers = retailersArray.filter(item => {
                return retailers?.find(retailer => { return retailer.retailer_id === item.retailer_id });
            });
            return selectedRetailers;
        }
    }

    getQuantityGivenNameById = (quantityGivenId) => {
        const quantityGivensArray = DataProvider.getInstance().getQuantityGivens();
        if (quantityGivensArray) {
            const item = quantityGivensArray.find(item => item.quantity_given_id === quantityGivenId);
            //Utilities.LogPrint("QuantityGiven", item);
            if (item) {
                const unitName = item?.weight_unit_name !== undefined ? item?.weight_unit_name : "";
                return item.quantity_given_name + " " + unitName;
            }
            return "";
        }
    }

    getCompetitorHybridNameById = (checkVarietyId) => {
        const { activity } = this.props;
        const competitorHybridArray = DataProvider.getInstance().getCompetitorHybrid(activity.hybrid_id);
        //Utilities.LogPrint("competitorHybrid", competitorHybridArray);
        if (competitorHybridArray) {
            const item = competitorHybridArray.find(item => item.competitor_hybrid_id === checkVarietyId);
            //Utilities.LogPrint("competitorHybrid", item);
            if (item) {
                return item.season_name;
            }
            return "";
        }
    }

    getSampleTypeNameById = (sampleTypeId) => {
        //Utilities.LogPrint("sampleType", sampleTypeId);
        const sampleTypes = DataProvider.getInstance().getTypeOfSamples();
        //Utilities.LogPrint("sampleType", sampleTypes);
        if (sampleTypes) {
            const item = sampleTypes.find(item => item.type_of_sample_id === parseInt(sampleTypeId));
            //Utilities.LogPrint("sampleType", item);
            if (item) {
                return item.type_of_sample_name;
            }
            return "";
        }
    }

    getRejectReasonById = (activityTypeId, rejectId) => {
        const rejectReasons = DataProvider.getInstance().getRejectReasons(activityTypeId);
        if (rejectReasons) {
            const reason = rejectReasons.find(item => item.reject_id === parseInt(rejectId));
            //Utilities.LogPrint("reason", reason);
            if (reason) {
                return reason.title;
            }
            return "";
        }
        return "";
    }


    render() {
        const { activity, user } = this.props;
        //Utilities.LogPrint("Activity Data ==", this.props.activity);

        //const { isLoading, activity, data, address } = this.state;

        if (activity) {
            const data = activity?.data;
            const nearByRetailers = this.getNearbyRetailersById(data?.sample_distribution_near_retailer);
            const quantity_given = this.getQuantityGivenNameById(data?.quantity_given_id);
            const check_variety = this.getCompetitorHybridNameById(data?.check_variety_id);
            const sampleType = this.getSampleTypeNameById(data?.type_of_sample);

            let reject = null;
            if (activity?.activity_reject !== null && activity?.activity_reject !== undefined) {
                reject = this.getRejectReasonById(activity.activity_type_id, activity.activity_reject.reject_id);
            }

            return (
                <div>

                    {/* Reject Reason */}
                    {
                        activity.activity_reject && activity.activity_status_id === 4 ?
                            <div className="row">
                                <div className="col-12 reject-activity-msg">
                                    <i className="customic ic-rejected"></i>
                                    <span>{reject}</span>
                                </div>
                            </div> : null
                    }

                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 col-md-4">
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">{CALENDER_SCREEN.FARMER_NAME}</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{user?.name}</span>
                                            <span className="d-block font-weight-medium">+91 - {user?.phone}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Quantity Given</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{quantity_given}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Check Variety</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{check_variety}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Type of Sample</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{sampleType}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Location</div>
                                        <div className="col-8 col-md-12">
                                            {/* <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span> */}
                                            <span className="d-block font-weight-medium">{data?.address ? data?.address : COMMON.LOCATION_ERROR_MESSAGE}</span>
                                        </div>
                                    </div>

                                    {nearByRetailers?.length > 0 ?
                                        <div className="row mb-3">
                                            <div className="col-4 col-md-12">Near by Retailers</div>
                                            <div className="col-8 col-md-12">
                                                {/* <span className="d-block font-weight-medium">Amjaid Hussian</span> */}
                                                {
                                                    nearByRetailers.map((item, i) => (
                                                        <span className="d-block font-weight-medium" key={i}>
                                                            {item.retailer_name}
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div> : null
                                    }

                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Are you going to do S2S?</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{data?.is_s2s === 1 ? "Yes" : 'NO'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="row mx-sm-0">
                                <hr className="w-100 bdr-color-gray m-0" />
                            </div>

                            <div className="row">
                                {/* Remarks */}
                                <div className="col-md-6 col-12">
                                    {data?.remark.length > 0 ?
                                        <div>
                                            <span className="d-flex w-100 align-items-center mt-2">{COMMON.REMARKS}</span>
                                            <span className="d-flex font-weight-medium mb-2">{data.remark}</span>

                                            <div className="row mx-sm-0 d-md-none">
                                                <hr className="w-100 bdr-color-gray m-0" />
                                            </div>
                                        </div> : null}
                                </div>

                                <div className="row mx-md-0">
                                    <hr className="w-100 bdr-color-gray m-0" />
                                </div>

                                <div className="col-md-6 col-12">
                                    <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mb-2">{COMMON.IMAGES}</span>
                                    <div className="row row7-5 mb-3">
                                        {
                                            data?.activity_images.length ?
                                                data?.activity_images.map((image, i) => (
                                                    <ViewOfflineImage key={i} image={image.image_url} />
                                                )) : null
                                        }
                                    </div>
                                </div>
                            </div>

                            <AcceptRejectButton
                                activity={activity}
                                handleAcceptButton={this.handleAcceptButton}
                                handleRejectButton={this.handleRejectButton}
                            />
                        </div>
                    </div>

                </div>
            )
        } else {
            return null;
        }
    }
}

export default withRouter(SampleDistributionView)